import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, ContentEntity, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { useSite, SliceLayoutBoundary, ContentEntityLayout, EntityTitleHeader } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';

const cls = classNames('404');

// -------- Types -------->

export type NotFoundPageProps = Classable & HasChildren & {
}

export const NotFoundPageDefaultProps: NotFoundPageProps = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  `,
});

const ContentStyles = breakpoints({
  base: css`
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Content: styled(ContentEntityLayout)`${ContentStyles}`
};

export const NotFoundPage: Shapeable.FC<NotFoundPageProps> = (props) => {
  const { className } = props;
  const site = useSite();
  
  const content: ContentEntity = {
    title: 'Page Not Found',
    content: {
      text: 
`Sorry, this page could not be found.  

Please use the site navigation to find what you're looking for, or [return to the home page](/).
`,
    }
  };

  return (
    <My.Container className={cls.name(className)}>
      <EntityTitleHeader entity={content} />
      <SliceLayoutBoundary verticalPadding='small'>
        <My.Content 
          showTitles={false}
          showMeta={false}
          showImage={false}
          entity={content} />
      </SliceLayoutBoundary>
    </My.Container>
  )
};

NotFoundPage.cls = cls;
NotFoundPage.defaultProps = NotFoundPageDefaultProps;
export default NotFoundPage;